import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { SocialIcon } from 'react-social-icons';
import { FaSun, FaMoon } from 'react-icons/fa'; // Import icons
import '../css/Home.css';
import Footer from '../components/Footer';

const Home = () => {
  // Initialize theme state with saved theme from localStorage or default to 'dark'
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');

  // Save theme to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Toggle theme
  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'dark' ? 'light' : 'dark'));
  };

  return (
    <div className={`home ${theme}`}>
      <Container className="home-container text-center">
        {/* Title and Theme Toggle Button Container */}
        <div className="home-title-container">
          <h1 className="home-title fade-in delay-1">basarsubasi.xyz</h1>
          <button className="theme-toggle" onClick={toggleTheme}>
            {theme === 'dark' ? <FaSun /> : <FaMoon />}
          </button>
        </div>
  
        {/* Social Media Icons Section */}
        <div className="social-icons fade-in delay-2">
          <SocialIcon
            url="https://github.com/basarsubasi"
            style={{ height: 50, width: 50 }}
            bgColor={theme === 'dark' ? '#ffffff' : 'black'}
            fgColor={theme === 'dark' ? '#232530' : '#f1e9d2'}
            target="_blank"
          />
          <SocialIcon
            url="https://instagram.com/basarsubasi"
            style={{ height: 50, width: 50 }}
            bgColor={theme === 'dark' ? '#ffffff' : 'black'}
            fgColor={theme === 'dark' ? '#232530' : '#f1e9d2'}
            target="_blank"
          />
          <SocialIcon
            url="https://www.youtube.com/@basarsubas5535"
            style={{ height: 50, width: 50 }}
            bgColor={theme === 'dark' ? '#ffffff' : 'black'}
            fgColor={theme === 'dark' ? '#232530' : '#f1e9d2'}
            target="_blank"
          />
          <SocialIcon
            url="mailto:basarsubasi@protonmail.com"
            style={{ height: 50, width: 50 }}
            bgColor={theme === 'dark' ? '#ffffff' : 'black'}
            fgColor={theme === 'dark' ? '#232530' : '#f1e9d2'}
            target="_blank"
          />
        </div>
  
        <div className="home-intro fade-in delay-3">
          <a
            href="https://blog.basarsubasi.xyz"
            target="_blank"
            rel="noopener noreferrer"
            className="blog-link"
          >
            Blog
          </a>
          <a
            href="https://gallery.basarsubasi.xyz"
            target="_blank"
            rel="noopener noreferrer"
            className="blog-link"
          >
            Gallery
          </a>
        </div>
      </Container>
      <Footer theme={theme} />
    </div>
  );
  
};

export default Home;
